import React, {Component} from "react";
import { connect } from "react-redux";

class QualifiedCongrats extends Component {
  render() {
    if (this.props.status !== "Fast Tracked" && this.props.status !== "Pending"){
      return "";
    } else {
      return (
        <div className="text-center">
          <h3><span style={{fontSize:'20px',display:'inline-block',marginBottom:'3px'}}>Congratulations,</span><br />
          You’ve qualified for ${this.props.loanamt}!</h3>
        </div>
      )
    }
  }
}

const mapStateToProps = (state) => ({
    status: state.FormReducer.status,
    loanamt: state.FormReducer.loanamt
});

export default connect(mapStateToProps)(QualifiedCongrats);



// WEBPACK FOOTER //
// ./src/components/views/Dashboard/partials/QualifiedCongrats.js